import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { HomePage } from './pages/HomePage';
import { ServicesPage } from './pages/ServicesPage';
import { FacilitiesPage } from './pages/FacilitiesPage';
import { GalleryPage } from './pages/GalleryPage';
import { FAQPage } from './pages/FAQPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen bg-h2o-950 text-slate-100 font-body selection:bg-h2o-cyan/30 selection:text-h2o-cyan-light flex flex-col" data-id="element-1">
        <Navbar data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/services" element={<ServicesPage data-id="element-7" />} data-id="element-6" />
          <Route path="/facilities" element={<FacilitiesPage data-id="element-9" />} data-id="element-8" />
          <Route path="/gallery" element={<GalleryPage data-id="element-11" />} data-id="element-10" />
          <Route path="/faq" element={<FAQPage data-id="element-13" />} data-id="element-12" />
          <Route path="/contact" element={<ContactPage data-id="element-15" />} data-id="element-14" />
        </Routes>
      </div>
    </BrowserRouter>;
}